import PropTypes from "prop-types";

export default PropTypes.shape({
  salaryMin: PropTypes.number,
  salaryMax: PropTypes.number,
  salaryType: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired,
  currencySymbol: PropTypes.string.isRequired,
});
